import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Kinder';
import '@fontsource/roboto-condensed/700.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        
      </Routes>
    </Router>
  );
}

export default App;
